import { api } from "../api";
import { NeededFiles } from "../interface";
import { store } from "../store";
import { lang } from "../lang";
import * as HelperSrc from "../HelperSrc";

async function getUploadList(workbook: string): Promise<NeededFiles[] | undefined> {
    if (!api.clientApi) {
        return undefined;
    }

    return api.clientApi.clientWorkbookUploadList(store.db ? store.db : "", workbook).then((response) => {
        if (response instanceof Error || (response.message && response.message.error)) {
            if (response instanceof Error) {
                HelperSrc.writeLog("error", response);
            } else {
                store.doNotice(lang[response.message.error]);
            }
        }

        return (response as unknown as { results?: NeededFiles[] }).results ?? [];
    });
}

export { getUploadList };
